import React, { useState, useEffect } from 'react';
import './CalculadoraFinanciacion.css';
import { Link } from 'react-router-dom';

const API_BASE_URL = 'https://us-central1-mariokarts-fee04.cloudfunctions.net/api';

const CalculadoraFinanciacion = () => {
  const [precio, setPrecio] = useState(20000);
  const [entrada, setEntrada] = useState(4000);
  const [interes, setInteres] = useState(7.5);
  const [plazo, setPlazo] = useState(72);
  const [cuotaMensual, setCuotaMensual] = useState(0);

  const [availableCars, setAvailableCars] = useState([]);
  const [selectedCarId, setSelectedCarId] = useState('');

  useEffect(() => {
    // Fetch available cars for the dropdown
    fetch(`${API_BASE_URL}/api/cars`)
      .then(response => response.json())
      .then(data => {
        const carsForDropdown = data
          .filter(car => !car.isSold)
          .sort((a, b) => {
            const nameA = `${a.brand} ${a.model}`.toUpperCase();
            const nameB = `${b.brand} ${b.model}`.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        setAvailableCars(carsForDropdown);
      })
      .catch(error => console.error('Error fetching cars for calculator:', error));
  }, []);

  useEffect(() => {
    const calcularCuota = () => {
      const capitalAPrestar = precio - entrada;
      if (capitalAPrestar <= 0) {
        setCuotaMensual(0);
        return;
      }

      const tasaInteresMensual = interes / 100 / 12;
      if (tasaInteresMensual === 0) {
        setCuotaMensual(capitalAPrestar / plazo);
        return;
      }

      const factor = Math.pow(1 + tasaInteresMensual, plazo);
      const cuota = (capitalAPrestar * tasaInteresMensual * factor) / (factor - 1);
      
      setCuotaMensual(cuota);
    };

    calcularCuota();
  }, [precio, entrada, interes, plazo]);

  const handleCarChange = (event) => {
    const carId = event.target.value;
    setSelectedCarId(carId);

    if (carId) {
      const selectedCar = availableCars.find(car => car.id === carId);
      if (selectedCar) {
        const numericPrice = parseInt(selectedCar.price.replace(/[^0-9]/g, ''), 10);
        setPrecio(numericPrice);
      }
    }
  };

  return (
    <div className="calculadora-container">
      <div className="calculadora-card">
        <h1 className="calculadora-title">Calculadora de Financiación</h1>
        <p className="calculadora-subtitle">
          Elige un coche de nuestro stock o introduce un importe para estimar tu cuota.
        </p>
        
        <div className="form-group">
            <label htmlFor="coche-select">Elige un coche (opcional)</label>
            <select id="coche-select" value={selectedCarId} onChange={handleCarChange} className="form-input">
                <option value="">-- Elige un coche para rellenar el precio --</option>
                {availableCars.map((car) => (
                    <option key={car.id} value={car.id}>
                        {car.brand} {car.model} - {car.price}€
                    </option>
                ))}
            </select>
        </div>

        <div className="form-group">
          <label>Precio del Vehículo (€)</label>
          <input 
            type="number" 
            value={precio} 
            onChange={(e) => {
              setPrecio(Number(e.target.value));
              setSelectedCarId(''); // Deselect car if price is manually changed
            }} 
            className="form-input"
          />
          <input 
            type="range" 
            min="5000" 
            max="150000" 
            step="1000"
            value={precio} 
            onChange={(e) => {
              setPrecio(Number(e.target.value));
              setSelectedCarId(''); // Deselect car if price is manually changed
            }} 
            className="form-range"
          />
        </div>

        <div className="form-group">
          <label>Entrada (€)</label>
          <input 
            type="number" 
            value={entrada} 
            onChange={(e) => setEntrada(Number(e.target.value))} 
            className="form-input"
          />
          <input 
            type="range" 
            min="0" 
            max={precio * 0.8}
            step="500"
            value={entrada} 
            onChange={(e) => setEntrada(Number(e.target.value))} 
            className="form-range"
          />
        </div>

        <div className="form-group">
          <label>Tipo de Interés Anual (%)</label>
          <input 
            type="number" 
            step="0.1"
            value={interes} 
            onChange={(e) => setInteres(Number(e.target.value))} 
            className="form-input"
          />
          <input 
            type="range" 
            min="2" 
            max="15" 
            step="0.1"
            value={interes} 
            onChange={(e) => setInteres(Number(e.target.value))} 
            className="form-range"
          />
        </div>

        <div className="form-group">
          <label>Plazo (meses)</label>
          <input 
            type="number" 
            value={plazo} 
            onChange={(e) => setPlazo(Number(e.target.value))} 
            className="form-input"
          />
          <input 
            type="range" 
            min="12" 
            max="120" 
            step="1"
            value={plazo} 
            onChange={(e) => setPlazo(Number(e.target.value))} 
            className="form-range"
          />
        </div>

        <div className="resultado-container">
          <h2>Cuota Mensual Estimada</h2>
          <p className="cuota-mensual">
            {cuotaMensual > 0 ? `${cuotaMensual.toFixed(2)} €` : '---'}
          </p>
          <small className="disclaimer">
            *Cálculo aproximado. No incluye seguros ni otros gastos. Sujeto a la aprobación de la entidad financiera.
          </small>
        </div>

        <div className="calculadora-actions">
            <Link to="/garaje" className="btn-ver-coches">Ver Coches en Venta</Link>
        </div>
      </div>
    </div>
  );
};

export default CalculadoraFinanciacion;